export const LOAD_FIELDS_META = 'load_fields_meta';
export const FIELDS_META_FAILED = 'loading_fields_meta_has_failed';
export const FIELDS_META_LOADED = 'set_loaded_fields_meta';
